import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

export default {
  state: {
    orders: [],
    currentOrder: null,
    evaluateOrder: false,
    idActionCable: "",
    lastOrder: null,
    ordersMeta: null,
    openCashbackModal: false,
  },
  mutations,
  actions,
  getters,
};
